import React, { useState } from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Trand_1 from '../../../assets/images/home_page_2/trending/01.png'
import Trand_2 from '../../../assets/images/home_page_2/trending/02.png'
import Trand_3 from '../../../assets/images/home_page_2/trending/03.png'
import Trand_4 from '../../../assets/images/home_page_2/trending/04.png'
import Trand_5 from '../../../assets/images/home_page_2/trending/05.png'
import Trand_6 from '../../../assets/images/home_page_2/trending/06.png'

const trand = {
    slidesToShow: 3,
    SlideToScroll: 1,
    Infinity: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 2000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 360,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
}


const Tranding = () => {
    const [ActiveTab, setActiveTab] = useState('pills-sculptures');

    const handleTabchange = (Tab) => {
        setActiveTab(Tab);
    }
    return (
        <>
            <section id="trending-product" className="trending-product-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="section">
                                <h2 className="section-title cormorant-font">Trending product</h2>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12">
                            <ul className="nav nav-pills float-end" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <Link
                                        className={`nav-link ${ActiveTab === "pills-sculptures" ? "active" : "show"}`}
                                        onClick={() => handleTabchange("pills-sculptures")}
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-sculptures"
                                        title=""
                                        role="tab"
                                        aria-controls="pills-sculptures"
                                        aria-selected="true"
                                    >
                                        Sculptures
                                    </Link>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <Link
                                        className={`nav-link ${ActiveTab === "pills-pottery" ? "active" : ""}`}
                                        onClick={() => handleTabchange("pills-pottery")}
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-pottery"
                                        title=""
                                        role="tab"
                                        aria-controls="pills-pottery"
                                        aria-selected="false"
                                    >
                                        Pottery
                                    </Link>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <Link
                                        className={`nav-link ${ActiveTab === "pills-porcelain" ? "active" : ""}`}
                                        onClick={() => handleTabchange("pills-porcelain")}
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-porcelain"
                                        title=""
                                        role="tab"
                                        aria-controls="pills-porcelain"
                                        aria-selected="false"
                                    >
                                        Porcelain
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="tab-content" id="pills-tabContent">
                        <div
                            className={`tab-pane fade ${ActiveTab === 'pills-sculptures' ? 'show active' : ''}`}
                            id="pills-sculptures"
                            role="tabpanel"
                        >
                            <Slider className="slider trending-product-autoplay" {...trand}>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_1}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_3}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_4}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_5}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_6}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_1}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                        <div
                            className={`tab-pane fade ${ActiveTab === 'pills-pottery' ? 'show active' : ''}`}
                            id="pills-pottery"
                            role="tabpanel"
                        >
                            <Slider className="slider trending-product-autoplay" {...trand}>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_1}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_3}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_4}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                        <div
                            className={`tab-pane fade ${ActiveTab === 'pills-porcelain' ? 'show active' : ''}`}
                            id="pills-porcelain"
                            role="tabpanel"
                        >
                            <Slider className="slider trending-product-autoplay" {...trand}>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_4}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_5}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_6}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="trending-product-autoplay-block">
                                    <div className="trending-product-block">
                                        <div className="trending-product-img">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Trand_1}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="trending-product-dtls text-center">
                                            <h4>
                                                <Link to="/Shopdetails" title="">
                                                    Potray Handcraft Bottle
                                                </Link>
                                            </h4>
                                            <p>$17.89</p>
                                            <Link to="#" title="" className="btn btn-primary-second">
                                                Buy Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Tranding
